export default __webpack_public_path__ + "static/media/loss.107d16ca.gif";